// TODO: Rename this file to constants

export const VisualizationType = Object.freeze({
  ScatterPlot: "ScatterPlot",
  CostModule: "CostModule",
});
